import React from 'react';
import moment from 'moment'
import {Link, useNavigate} from 'react-router-dom';
import cx from 'classnames';
import './TableRow.css';

const TableRow = (props) => {
    const navigate = useNavigate();

    const handlePopup = (url, fields, footer, title, type, id) => {
        props.handlePopup(url, fields, footer, title, type, id);
    };

    const handleRowClick = (e, pk) => {
        // Don't trigger row click if clicking on a button or link
        if (e.target.tagName.toLowerCase() === 'button' || 
            e.target.tagName.toLowerCase() === 'a' ||
            e.target.closest('button') ||
            e.target.closest('a')) {
            return;
        }
        e.preventDefault();
        if (props.onclick === 'link') {
            navigate(props.link.replace('{id}', pk));
        } else if (props.onclick === 'view') {
            handlePopup(props.view.url, props.view.fields, props.view.footer, props.view.title, props.view.type, pk);
        }
    };

    const handleDelete = (pk) => {
        props.handleDelete(pk);
    };

    if (props.row.hidden === true) {
        return null;
    }

    let pk = props.id;
    const {prefs} = props;
    return (
        <tr key={pk} onClick={(e) => handleRowClick(e, pk)} className={props.onclick === 'link' || props.onclick === 'view' ? 'cursor-pointer' : ''}>
            {props.metadata.map((col, index) => {
                if (col.visible === false) {
                    return null;
                }
                if (col.type === undefined) {
                    return <td key={index}>{props.row[col.source]}</td>
                } else if (col.type === 'primary') {
                    pk = props.row[col.source];
                    return null;
                } else if (col.type === 'icon') {
                    return <td key={index}><div className={col.classnames[props.row[col.source]]}>{col.values[props.row[col.source]]}</div></td>
                } else if (col.type === 'enum') {
                    const value = props.row[col.source];
                    const classname = col.classnames[value];
                    return <td key={index}>
                        <span className={classname}>
                            {value}
                        </span>
                        </td>
                } else if (col.type === 'select') {
                    const key = props.row[col.source];
                    const meta = props.remotemeta?.[col.source];
                    return <td key={index} style={{textAlign: 'left'}}>{meta?.values?.[key]}</td>
                } else if (col.type === 'datetime') {
                    return <td key={index}>{moment(props.row[col.source]).format('YYYY-MM-DD HH:mm:ss')}</td>
                } else if (col.type === 'datetimefull') {
                    const utcTime = zonedTimeToUtc(new Date(props.row[col.source]),"UTC");
                    try {
                        return <td key={index}>{utcTime.toLocaleString(prefs.locale,{timeZoneName:'short', timeZone: prefs.tz})}</td>
                    } catch (err) {
                        return <td key={index}>{props.row[col.source]}</td>
                    }
                } else if (col.type === 'date') {
                    return <td key={index}>{moment(props.row[col.source]).format('YYYY-MM-DD')}</td>
                } else if (col.type === 'time') {
                    return <td key={index}>{moment.utc(props.row[col.source]*1000).format('HH:mm:ss')}</td>
                } else if (col.type === 'component') {
                    return <td key={index}>{col.component(props.row[col.source])}</td>
                } else if (col.type === 'money4') {
                    const value = parseFloat(props.row[col.source]);
                    return <td key={index} style={{textAlign: 'right'}} className={cx( value <0 ? "danger" : "")}>{value.toFixed(4)}</td>
                } else if (col.type.startsWith('money')) {
                    const value = parseFloat(props.row[col.source]);
                    return <td key={index} style={{textAlign: 'right'}} className={cx( value <0 ? "danger" : "")}>{value.toFixed(2)}</td>
                } else if (col.type === 'popup') {
                    return (
                        <td key={index}>
                            <button
                                className="btn btn-view"
                                onClick={() => handlePopup(col.url, col.fields, col.footer, col.title, col.type, pk)}
                            >
                                {col.label}
                            </button>
                        </td>
                    )
                } else if (col.type === 'boolean') {
                    return <td key={index} style={{textAlign: 'center', width: '100px'}}>
                        <span style={{width: '40px'}} className={props.row[col.source] ? 'badge badge-success' : 'badge badge-danger'}>
                            {props.row[col.source] ? 'Yes' : 'No'}
                        </span>
                    </td>
                } else if (col.type === 'link') {
                    const url = col.value.replace(/\{\$(\w+)\}/g, (_, key) => props.row[key])
                    return <td key={index} style={{width: '120px'}}><Link className="view-link" to={url}>{col.label}</Link></td>
                } else if (col.type === 'link_href') {
                    const url = col.value.replace(/\{\$(\w+)\}/g, (_, key) => props.row[key])
                    return <td key={index} style={{width: '120px'}}><a className="btn btn-view" style={{padding: '4px 4px 0 4px', margin: '0 4px'}} href={url}>{col.label}</a></td>
                } else if (col.type === 'delete') {
                    return <td style={{width: '30px', padding: '4px 4px 0px 4px'}} key={index}><button className="btn btn-danger" style={{padding: '4px 4px 0 4px', margin: '0 4px'}} onClick={(e) => {
                        e.preventDefault();
                        if (window.confirm('Are you sure you want to delete this item?')) {
                            handleDelete(pk)
                        }
                    }}><i className="material-icons" style={{fontSize: '20px'}}>delete</i></button></td>
                } else {
                    return <td key={index} style={{textAlign: 'left'}}>{props.row[col.source]}</td>
                }
            })}
        </tr>
    );
};

export default TableRow;